/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {putAuditLog} from '../api'

export const useMutationPutAuditLog = createReactQueryMutationHook('putAuditLog', putAuditLog)
